var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 77"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 22",
    x: 1.5,
    width: 23.3343,
    height: 2.1213,
    rx: 1.06065,
    transform: "rotate(45 1.5 0)",
    fill: "#39373A"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 23",
    x: 17.9999,
    y: 1.49999,
    width: 23.3343,
    height: 2.1213,
    rx: 1.06065,
    transform: "rotate(135 17.9999 1.49999)",
    fill: "#39373A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.36769b30008a4eba2bdf6d41efebc9ac.svg";
export { ForwardRef as ReactComponent };